(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const atcTrigger = document.querySelector('.quick-add-atc-trigger');

    if (atcTrigger) {
      // Click event to trigger add to cart
      atcTrigger.addEventListener('click', function(e) {
        e.preventDefault();

        const modalContent = document.getElementById('quick-add-modal-content');
        const addToCartButton = modalContent?.querySelector('.add-to-cart-button');

        if (addToCartButton) {
          addToCartButton.click();
        } else {
          console.warn('No .add-to-cart-button found in quick-add-modal-content');
        }
      });

      // Function to copy buy-buttons-block content to atc-trigger
      const updateAtcTriggerContent = () => {
        const buyButtonsBlock = document.querySelector('.quick-add-modal .buy-buttons-block');
        if (buyButtonsBlock) {
          atcTrigger.innerHTML = buyButtonsBlock.innerHTML;
        }
      };

      // Observe for changes in the quick-add-modal content
      const observer = new MutationObserver((mutations) => {
        updateAtcTriggerContent();
      });

      const modalContent = document.getElementById('quick-add-modal-content');
      if (modalContent) {
        observer.observe(modalContent, { childList: true, subtree: true });
      }

      // Initial update
      updateAtcTriggerContent();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
